import getUrlPath from '@app/utils/getUrlPath';
import useEnhancedNavigation from '@app/hooks/useEnhancedNavigation';
import { BreadcrumbLink, BreadcrumbsRoot, BreadcrumbText } from './BreadcrumbsStyle';
import { ReactNode } from 'react';
import { UrlSubTree } from '@app/types/url';

interface BreadcrumbsProps {
  breadcrumbs: Breadcrumb[];
}

export interface Breadcrumb {
  title: ReactNode;
  url?: string | UrlSubTree;
}

function Breadcrumbs({ breadcrumbs }: BreadcrumbsProps) {
  const navigate = useEnhancedNavigation();

  return (
    <BreadcrumbsRoot separator='/'>
      {breadcrumbs.map((breadcrumb, index) =>
        breadcrumb.url ? (
          <BreadcrumbLink
            key={index}
            onClick={() =>
              navigate(
                typeof breadcrumb.url === 'string'
                  ? breadcrumb.url
                  : getUrlPath(breadcrumb.url as UrlSubTree),
              )
            }
          >
            {breadcrumb.title}
          </BreadcrumbLink>
        ) : (
          <BreadcrumbText key={index}>{breadcrumb.title}</BreadcrumbText>
        ),
      )}
    </BreadcrumbsRoot>
  );
}

export default Breadcrumbs;
